import {
  FiHome,
  FiUsers,
  FiMessageCircle,
  FiCreditCard,
  FiMaximize,
  FiShoppingBag,
  FiSliders,
  FiLifeBuoy,
} from 'react-icons/fi'

export const SUPPORT_EMAIL = 'support@loyalideas.com'

const navEntries = [
  {
    key: 'overview',
    label: 'Overview',
    to: '/',
    icon: FiHome,
    match: ['/'],
    exact: true,
  },
  {
    key: 'subscribers',
    label: 'Subscribers',
    to: '/customers',
    icon: FiUsers,
    match: ['/customers'],
  },
  {
    key: 'messages',
    label: 'Messages',
    to: '/broadcast',
    icon: FiMessageCircle,
    match: ['/broadcast'],
  },
  {
    key: 'cards',
    label: 'Cards',
    to: '/campaigns',
    icon: FiCreditCard,
    match: ['/campaigns', '/platform/campaigns'],
    tabs: [
      { label: 'Campaigns', to: '/campaigns' },
      {
        label: 'Platform campaigns',
        to: '/platform/campaigns',
        roles: ['super_admin'],
      },
    ],
  },
  {
    key: 'scan',
    label: 'Scan',
    to: '/scan',
    icon: FiMaximize,
    match: ['/scan'],
  },
  {
    key: 'store',
    label: 'Store & Orders',
    to: '/order-management',
    icon: FiShoppingBag,
    match: ['/order-management'],
  },
  {
    key: 'settings',
    label: 'Settings',
    to: '/settings',
    icon: FiSliders,
    match: ['/settings', '/account', '/team', '/rebranding'],
    tabs: [
      { label: 'Organisation', to: '/settings', end: true },
      { label: 'Account', to: '/account' },
      { label: 'Team', to: '/team' },
      { label: 'Branding', to: '/rebranding', paidOnly: true },
      { label: 'Invoices', to: '/settings/invoices' },
      { label: 'Subscription ↗', to: '/subscribe' },
    ],
  },
  {
    key: 'support',
    label: 'Support',
    to: '/help',
    icon: FiLifeBuoy,
    match: ['/help'],
    pinned: 'bottom',
  },
]

const allowedForUser = (item, user) =>
  !item.roles || item.roles.includes(user?.role)

const isFreePlan = (user) => user?.account?.plan === 'free'

export const getNavEntries = (user) =>
  navEntries
    .filter((entry) => allowedForUser(entry, user))
    .map((entry) => ({
      ...entry,
      tabs: entry.tabs
        ?.filter((tab) => allowedForUser(tab, user))
        .map(({ paidOnly, roles, ...tab }) =>
          paidOnly && isFreePlan(user)
            ? { ...tab, to: '/subscribe', locked: true }
            : tab
        ),
    }))

const matchesPrefix = (pathname, prefix, exact) => {
  if (exact) return pathname === prefix
  return pathname === prefix || pathname.startsWith(`${prefix}/`)
}

export const getActiveEntry = (pathname, user) =>
  getNavEntries(user).find((entry) =>
    entry.match.some((prefix) => matchesPrefix(pathname, prefix, entry.exact))
  )
